import { ReactNode } from 'react';

import samLoader from '../../assets/sam/sam_loader.gif';
import { LoadingScreen } from './LoadingScreen.tsx';
import { LongLoaderProps } from './types.ts';

type LoadingScreenSamProps = {
  what?: string;
  fadeIn?: boolean;
  lightText?: boolean;
  overrideText?: string;
  longLoaderProps?: LongLoaderProps;
  overrideComponent?: ReactNode;
  logoWidth?: string;
};

export const LoadingScreenSamInline = ({
  fadeIn,
  longLoaderProps,
  logoWidth,
  overrideComponent,
  ...props
}: LoadingScreenSamProps) => (
  <LoadingScreen
    logoSrc={samLoader}
    logoWidth={logoWidth ?? '100%'}
    animationClassName={
      fadeIn ? 'loading-screen-animation-fade-in-250ms' : 'loading-screen-animation-none'
    }
    overrideComponent={overrideComponent}
    {...props}
    wrapperProps={{ flexDirection: 'row', justifyContent: 'flex-start' }}
  />
);
